import type { MouseEvent, Ref } from "react";

import { cx } from "class-variance-authority";

import { Tooltip } from "../Tooltip";

import { SidebarLockBadge } from "./icons/SidebarLockBadge";
import { SidebarCountBadge } from "./SidebarCountBadge";
import { SidebarRow } from "./SidebarRow";
import * as theme from "./SidebarSubMenuItem.css";

export interface SidebarSubMenuItemProps {
    label: string;
    /** Renders an anchor when given, a button otherwise. */
    href?: string;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
    count?: number;
    /** The page currently open. */
    active?: boolean;
    locked?: boolean;
    lockedTooltip?: string;
    ref?: Ref<HTMLElement>;
    className?: string;
}

export function SidebarSubMenuItem({
    label,
    href,
    onClick,
    count,
    active = false,
    locked = false,
    lockedTooltip,
    ref,
    className,
}: SidebarSubMenuItemProps) {
    const tooltip = locked ? lockedTooltip : undefined;

    return (
        <Tooltip
            title={tooltip}
            placement="right"
            noWrapper
            disabled={tooltip === undefined}
        >
            <SidebarRow
                href={href}
                locked={locked}
                onClick={onClick}
                ref={ref}
                data-slot="sidebar-sub-menu-item"
                className={cx(
                    theme.root,
                    active && theme.active,
                    locked && theme.locked,
                    className
                )}
                aria-current={active ? "page" : undefined}
            >
                <span className={theme.label}>{label}</span>
                {locked ? (
                    <SidebarLockBadge />
                ) : (
                    <SidebarCountBadge count={count} />
                )}
            </SidebarRow>
        </Tooltip>
    );
}
